// Eliminar .example para poder utilizar el environment
export const environment = {
  production: false,
  baseApiUrl: 'https://server.followthealpaca.com/api/',
  baseStorageUrl: 'https://server.followthealpaca.com/storage/',
};